import React, { createContext, useEffect, useState } from 'react'

const UserDataContext = createContext();

const UserContext = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const checkAuth = () => {
            const collectorData = localStorage.getItem('collectors_data');
            const adminToken = localStorage.getItem('access_token');
            const adminName = localStorage.getItem('username');

            if (collectorData) {
                const parsed = JSON.parse(collectorData);
                setUser({ ...parsed, role: 'COLLECTOR', authenticated: true });
            } else if (adminToken && adminName) {
                setUser({ name: adminName, role: 'ADMIN', authenticated: true });
            } else {
                setUser({ authenticated: false });
            }
            setIsLoading(false);
        };
        checkAuth();
    }, []);

    return (
        <UserDataContext.Provider value={{ user, setUser, isLoading }}>
            {children}
        </UserDataContext.Provider>
    )
}

export { UserContext, UserDataContext };